export enum OpenSidebar {
    updateTags,
    addTags,
    addLabels,
    renameTags,
    changeTagValues,
    removeTags,
    copyTags,
    undefined,
    removeLabels,
    renameLabels,
    changeLabelValues,
}
